<template>
  <section class="step3-form" :style="{minHeight:(screenHeight-85)+'px'}">
    <div class="step-form__step-num">3/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">银行卡信息确认</h1>
      <div class="bankcard-list-container" v-show="showList">
        <ul class="bankcard-list">
          <li :key="item.bankAccountId" :class="['bankcard-list__list-item', item.selected ? 'is-selected' : '']"
              v-for="item in bankcardList" @click="selectBankcard(item)">
            <div class="bankcard-list__list-item__btn-container">
              <span @click.stop="checkForm(item)">查看</span>
            </div>
            <h5 class="bankcard-list__list-item__bank-name">{{item.bankName}}</h5>
            <h6 class="bankcard-list__list-item__branch-bank-name">{{item.bankBranchName}}</h6>
            <div class="bankcard-list__list-item__bankcard-num">{{item.bankAccountName | replaceBankcardNumWithStar}}
            </div>
          </li>
        </ul>
      </div>
      <div class="bankcard-form-container" v-show="!showList">
        <el-row :gutter="0" class="step-form__form">
          <el-col :span="16">
            <el-form :label-width="'50%'" :model="bankcardForm" ref="bankcardForm">
              <el-form-item label="账户种类">
                <el-select v-model="bankcardForm.bankType" :disabled="true" placeholder="请选择账户种类">
                  <el-option v-for="item in cardTypeList" :key="item.value" :label="item.text"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开户名称">
                <el-input type="text" v-model="bankcardForm.bankUserName" :disabled="true"
                          placeholder="请输入开户名称"></el-input>
              </el-form-item>
              <el-form-item label="银行所属区域">
                <el-cascader :options="regionData" :props="bankRegionProps" :disabled="true"
                             v-model="bankcardForm.bankRegion" v-if="regionData"
                             placeholder="请选择银行所属区域"></el-cascader>
              </el-form-item>
              <el-form-item label="开户银行">
                <el-select v-model="bankcardForm.bankName" filterable remote :remote-method="searchBankName"
                           :disabled="true" placeholder="请输入开户银行">
                  <el-option v-for="item in bankNameData" :key="item.value" :label="item.text"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="支行名称">
                <el-input type="text" v-model="bankcardForm.bankBranchName" :disabled="true"
                          placeholder="请输入支行名称"></el-input>
              </el-form-item>
              <el-form-item label="开户账户">
                <el-input type="text" v-model="bankcardForm.bankAccountName" :disabled="true"
                          placeholder="请输入开户账户"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="step-form__btn-container" v-if="showList">
        <button class="step-form__btn-prev" @click="goBack">上一步</button>
        <button class="step-form__btn-next" @click="goNext">下一步</button>
      </div>
      <div class="step-form__btn-container" v-else>
        <button class="step-form__btn-next" @click="showList = true">取消</button>
      </div>
    </div>
  </section>
</template>
<script>
  import _ from 'lodash'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'
  import api from '../../vuex/api'

  export default {
    data () {
      return {
        showList: true,
        isSubmitting: false,
        selectedBankcardId: '',
        screenHeight: document.body.clientHeight,
        bankRegionProps: {
          value: 'code',
          label: 'name',
          children: 'children'
        },
        bankNameData: [],
        bankcardForm: {
          bankType: '',
          bankUserName: '',
          bankRegion: [],
          bankName: '',
          bankNameValue: '',
          bankBranchName: '',
          bankAccountId: '',
          bankAccountName: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        userInfo: types.GET_USER,
        bankcardList: types.GET_BANKCARD_LIST,
        cardTypeList: types.GET_CARD_TYPE_LIST,
        regionData: types.GET_REGION_DATA,
        selectedBankID: types.GET_SELECTED_BANK_ID_STATE,
        selectedBankNO: types.GET_SELECTED_BANK_NO_STATE
      })
    },
    methods: {
      ...mapActions({
        getBankcardList: types.SET_BANKCARD_LIST,
        getProvinceData: types.SET_PROVINCE_DATA,
        getCityAndDistrictData: types.SET_CITY_AND_DISTRICT_DATA,
        saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      ...mapMutations({
        setSelectedBankcard: types.SELECT_BANKCARD,
        setSelectedBankID: types.SET_SELECTED_BANK_ID_STATE,
        setSelectedBankNO: types.SET_SELECTED_BANK_NO_STATE
      }),
      checkForm (bankcard) {
        // 因为element ui的限制，没有对应数据显示不出文本框里面对应层级的文字……
        this.getCityAndDistrictData({
          val: [bankcard.bankProvince]
        }).then(() => {
          this.getCityAndDistrictData({
            val: [bankcard.bankProvince, bankcard.bankCity]
          }).then(() => {
            this.showList = false
            this.isEditBankcard = false
            this.bankcardForm = {
              bankType: bankcard.bankType,
              bankUserName: bankcard.bankUserName,
              bankRegion: [bankcard.bankProvince, bankcard.bankCity, bankcard.bankCounty],
              bankName: bankcard.bankName,
              bankNameValue: bankcard.bankNameValue,
              bankBranchName: bankcard.bankBranchName,
              bankAccountId: bankcard.bankAccountId,
              bankAccountName: bankcard.bankAccountName
            }
            this.addBankcardNumSpaces()
          })
        })
      },
      goBack () {
        this.saveApplyLoanProgress({
          router: this.$router,
          token: this.userInfo.token,
          id: this.$route.query.applyLoanId,
          step: 2
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            if (`${this.$route.query.isEdit}` === 'true') {
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step2_xd`,
                query: {
                  applyLoanId: this.$route.query.applyLoanId,
                  isEdit: this.$route.query.isEdit
                }
              })
            } else {
              this.$router.go(-1)
            }
          }
        })
      },
      goNext () {
        // 校验是否已经选中银行卡，不是的话警告，是的话保存并跳转
        const selectedBankcard = _.find(this.bankcardList, item => item.selected === true)
        //  当列表只有一直银行卡的时候，默认选中提交第一张银行卡
        if (this.bankcardList.length === 1) {
          this.selectBankcard(this.bankcardList[0])
        }
        if (_.isEmpty(selectedBankcard)) {
          this.setFailMessage({
            show: true,
            content: '请选择银行卡'
          })
        } else {
          this.saveApplyLoanProgress({
            router: this.$router,
            token: this.userInfo.token,
            id: this.$route.query.applyLoanId,
            bankAccountId: this.selectedBankID,
            step: 3
          }).then((res) => {
            const resData = res.data
            if (Number(resData.code) === 0) {
              this.isSubmitting = false
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step4_xd`,
                query: {
                  applyLoanId: this.$route.query.applyLoanId,
//                  selectedBankcardId: this.selectedBankcardId
                  selectedBankcardId: this.selectedBankID
                }
              })
            }
          })
        }
      },
      addBankcardNumSpaces () {
        const spaceRE = /(\s*)/g  // 正则-所有空格
        const spaceEndRE = /(\s*$)/g  // 正则-末位空格
        this.bankcardForm.bankAccountName = this.bankcardForm.bankAccountName.replace(spaceRE, '').replace(/(\d{4})(?=\d)/g, '$1 ').replace(spaceEndRE, '') // 替换末位空格
      },
      searchBankName (bankName) {
        api.getBankcardSelectData({
          router: this.$router,
          token: this.userInfo.token,
          bankName
        }).then((res) => {
          const resData = res.data
          if (Number(resData.code) === 0) {
            this.bankNameData = resData.bankNameList
          } else {
            this.bankNameData = []
          }
        })
      },
      selectBankcard (bankcard) {
//        this.selectedBankcardId = bankcard.bankAccountId
        this.setSelectedBankID(bankcard.bankAccountId)
        this.setSelectedBankNO(bankcard.bankAccountName)
        this.setSelectedBankcard({
          bankAccountId: bankcard.bankAccountId
        })
      }
    },
    mounted () {
      this.$store.commit('changeActive', 3);
      this.getBankcardList({
        token: this.userInfo.token,
        id: this.$route.query.applyLoanId,
        selectedBankcardId: this.$route.query.selectedBankcardId
      })
      this.getProvinceData()
    }
  }
</script>
<style lang="scss">
  @import "../../styles/bankcardList";

  .step3-form .step-form__title {
    padding-bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// Step3_bak.vue?42541d1c